import React, {fileInputRef, useRef} from 'react';
import {UploadIcon} from "../../assets/icons/Icons";

const UploadButton = (props) => {

    const fileInputRef = useRef(null);
    const handleUploadButtonClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (e) => {
        props.onChange(e);
    };

    return (
        <span className="upload-button">
            <button onClick={handleUploadButtonClick} className={props.class}>
                {props.title}
            </button>
            <input
                type="file"
                ref={fileInputRef}
                style={{display: 'none'}}
                accept={props.accept}
                onChange={handleFileChange}
            />
        </span>);
};

export default UploadButton;